import React, { ReactNode, useState } from "react";
import styled from "@emotion/styled";
import { Modal } from "../Modal";
import { Checkbox } from "../Checkbox";
import type { ContactType, Modal as ModalType } from "./types";
import { TEST_ID_PREFIX } from "./constants";

const ContactCardModal = ({
  modal,
  contactType,
  onClose,
}: ContactCardModalProps) => {
  const [isChecked, setIsChecked] = useState(false);

  const { type, heading, confirm, body, buttonLabel, action } = modal;

  return (
    <Modal
      type={type ?? "warning"}
      title={heading}
      customModalWidth={820}
      onClose={onClose}
      primaryButton={{
        text: buttonLabel,
        onClick: action,
        disabled: Boolean(confirm) && !isChecked,
        testId: `${TEST_ID_PREFIX[contactType]}-modal-update`,
      }}
      secondaryButton={{
        text: "Cancel",
        onClick: onClose,
        testId: `${TEST_ID_PREFIX[contactType]}-modal-cancel`,
      }}
    >
      <>
        {body ?? null}
        {confirm && (
          <CheckBoxContainer>
            <CheckBoxStyled
              label={confirm}
              name="update-warning-checkbox"
              data-testid={`${TEST_ID_PREFIX[contactType]}-modal-agree-to-update`}
              onChange={() => setIsChecked(!isChecked)}
              value={String(isChecked)}
            />
          </CheckBoxContainer>
        )}
      </>
    </Modal>
  );
};

interface ContactCardModalProps {
  modal: ModalType & { action: () => void; body?: ReactNode };
  contactType: ContactType;
  onClose: () => void;
}

const CheckBoxStyled = styled(Checkbox)`
  color: var(--black);
  span {
    margin-left: 12px;
  }
`;

const CheckBoxContainer = styled.div`
  margin-top: 24px;
`;

export type { ContactCardModalProps };

export { ContactCardModal };
